<template>
    <div class="c-cekajici-resene__wrap" >
        <div class="c-cekajici-resene__karta" v-for="item in events" v-bind:key="item.entityId">
            <DropContainer @dragged="dragged" >
                <eventCard 
                    v-bind="{item}"
                    @openEventModal="openEventEditModal"
                    @openCrewListModal="openCrewListModal"
                ></eventCard>
            </DropContainer>

        </div>


        <crewListModal v-if="showCrewListModal"
                        @close="showCrewListModal = false"
                       :event="selectedEvent"
        ></crewListModal>
    </div>
</template>

<script>


    import crewListModal from '@/components/crewListModal.vue';
    import getPropertyValue from '@/mixins/getPropertyValue.js';
    import eventCard from './eventCard';
    import DropContainer from './DropContainer';
    import {mapActions} from 'vuex';

    export default {
        name: 'EventsList',
        components: {
            crewListModal,
            eventCard,
            DropContainer
        },
        data: function () {
            return {
                event: 'Událost',
                selectedEventId: '',
                selectedEvent: null,
                crewList: [],

                showCrewListModal: false,
                randomKey: 0
            }
        },
        methods: {
            getUrgencyColor (urgency) {
                switch (Number(urgency)) {
                    case 1 : return 'c-karta__num--red';
                    case 2 : return 'c-karta__num--yellow';
                    case 3 : return 'c-karta__num--green';
                    case 4 : return 'c-karta__num--grey';
                    default: ''
                }
            },
            openEventEditModal (eventId) {
                this.$emit('openEventEditModal', eventId);
            },
            openCrewListModal (event) {
                this.selectedEvent = event;
                this.showCrewListModal = true;
            },

            getPropertyValue,

            async dragged(args){
                console.log('Drag registered:', args);
                if(args){
                    if(args.label === 'crewList'){
                        const event = args.to, ambulance = args.from;
                        try {
                            await this.sendCommand({cmd: (this.$store.state.editMode ? 'sendAmbulanceScenario' : 'sendAmbulance'), payload: {event, ambulance}});
                            this.$eventHub.$emit('openMessageController', 'success' , this.translate('Popups.text1'));
                            console.log('Sanitka uspesne prirazena');
                        } catch(e) {
                            this.$eventHub.$emit('openMessageController', 'error' , e);
                            console.log('Přatažení se nepovedlo:', e);
                        }
                    }
                }
            },

            ...mapActions(['sendCommand'])
        },
        computed:{
            events () {


                if (this.typeOfEventList==='waitingEvents') {
                   return this.$store.state.simulation.lists.waitingEvents;
                } else if (this.typeOfEventList==='assignedEvents') {
                    return this.$store.state.simulation.lists.assignedEvents;
                } else if (this.typeOfEventList==='cancelledEvents') {
                    return this.$store.state.simulation.lists.cancelledEvents;
                } else if (this.typeOfEventList==='solvedEvents') {
                    return this.$store.state.simulation.lists.archivedEvents;
                } else if (this.typeOfEventList==='forwardedEvents') {
                    return this.$store.state.simulation.lists.forwardedEvents;
                } else {
                    return this.$store.state.simulation.lists.alarmedEvents;
                }


            }
        },
        props: {
            typeOfEventList: String
        }
    }
</script>

<style lang="less" scoped>

</style>